import React from 'react';
import styled from 'styled-components';
import { Skeleton } from '../ui/primitives';

/** Shimmer block for a KPI stat value while a count is fetching. */
export function StatValueShimmer() {
  return (
    <Skeleton
      $w="48px"
      $h="26px"
      $r="6px"
      aria-hidden="true"
    />
  );
}

const DomainShimmerRow = styled.div`
  padding: 9px 0;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.border};
  }
`;

const DomainShimmerHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const DomainShimmerList = styled.div`
  margin-top: 6px;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/**
 * Shimmer rows for the Domains & subdomains panel — matches loaded DomainRow layout
 * so the card height stays stable while data fetches.
 */
export function DomainsPanelShimmer() {
  return (
    <div aria-busy="true" aria-label="Loading domains">
      {[72, 64, 58].map((titleWidth, index) => (
        <DomainShimmerRow key={index}>
          <DomainShimmerHead>
            <Skeleton $w={`${titleWidth}%`} $h="13px" $r="6px" />
            <Skeleton $w="32px" $h="11px" $r="6px" />
          </DomainShimmerHead>
          <DomainShimmerList>
            <Skeleton $w="88%" $h="11px" $r="6px" />
            <Skeleton $w="76%" $h="11px" $r="6px" />
          </DomainShimmerList>
        </DomainShimmerRow>
      ))}
    </div>
  );
}
